import { Trans } from '@lingui/macro';
import { Stack } from '@mui/material';
import { noddiAsync, URLKeys } from 'noddi-async';
import { useAuthContext } from 'noddi-provider';
import { CampaignPublic } from 'noddi-types';
import { NoddiButton } from 'noddi-ui-common';
import { NoddiBasicCard } from 'noddi-ui-web';
import { ApiErrorMessageWithTrans } from '../../components/ApiErrorMessageWithTrans';
import NewBookingButton from '../../components/NewBookingButton/NewBookingButton';

interface ActivateCampaignProps {
  campaign: CampaignPublic;
}
// eslint-disable-next-line import/no-default-export
export default function ActivateCampaign({ campaign }: ActivateCampaignProps) {
  const { currentUserGroupId } = useAuthContext();

  const {
    mutateAsync: activateCampaign,
    isPending: isActivateCampaignPending,
    isSuccess: isActivateCampaignSuccess,
    error: activateCampaignError
  } = noddiAsync.usePost({
    type: URLKeys.postActivateCampaign
  });

  if (!currentUserGroupId) {
    throw new Error('User group id is required');
  }

  return (
    <Stack>
      {isActivateCampaignSuccess ? (
        <div className='flex flex-col gap-2'>
          <NoddiBasicCard className='flex gap-2'>
            🎉
            <span>
              <Trans>The coupons have been activated!</Trans>
            </span>
          </NoddiBasicCard>
          <p>
            <Trans>You can now make a new booking with your coupons.</Trans>
          </p>
          <NewBookingButton defaultSize loading={isActivateCampaignPending} />
        </div>
      ) : (
        <div className='flex flex-col gap-2'>
          {activateCampaignError && <ApiErrorMessageWithTrans error={activateCampaignError} />}
          <NoddiButton
            loading={isActivateCampaignPending}
            onPress={async () =>
              await activateCampaign({
                userGroupId: currentUserGroupId,
                campaignId: campaign.id
              })
            }
          >
            <Trans>Activate coupons</Trans>
          </NoddiButton>
        </div>
      )}
    </Stack>
  );
}
